// deepClone.ts
// Utility to deep clone any object, using structuredClone if available, otherwise JSON fallback.

export function deepClone<T>(obj: T): T {
  if (typeof structuredClone === 'function') {
    return structuredClone(obj);
  }
  return JSON.parse(JSON.stringify(obj));
}
